import KPIList from './KPIList';

export default KPIList;
